"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { commonApiFetch } from "@/services/api/common-api";
export function useMemeCardCount(t0) {
  const $ = _c(3);
  const {
    enabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [QueryKey.MEMES_LATEST, {
      scope: "meme-card-set-count"
    }];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== enabled) {
    t2 = {
      queryKey: t1,
      queryFn: _temp,
      enabled,
      staleTime: 300000
    };
    $[1] = enabled;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return useQuery(t2);
}
async function _temp() {
  const response = await commonApiFetch({
    endpoint: "memes_extended_data",
    params: {
      page_size: "1"
    }
  });
  return response.count;
}